import styled from 'styled-components';
import { TextButton } from '@riac/design-system';
import { OutlineButton } from '@riac/design-system';
import { ContentContainer } from '@riac/design-system';

export const CustomerProductQuestionsArea = styled.div`
  margin-bottom: 3em;
  ${({ theme }) => theme.desktop} {
    margin-bottom: 6rem;
  }

  @media print {
    display: none;
  }

  > ${ContentContainer} {
    padding-bottom: 1em;
  }
`;

export const DetailPagePublicQuestionContainer = styled.li`
  background-color: rgba(255, 255, 255, 0.05);
  flex: 1;
  list-style: none;
  width: 100%;
  max-width: 550px;
  padding: 10px;
  margin: 10px auto;
  p {
    margin-bottom: 10px;
  }
`;

export const CustomerProductQuestionTextArea = styled.div`
  width: 100%;
  max-width: 55rem;
  label, textarea {
    margin-bottom: 0;
  }
  textarea {
    width: 100%;
    height: 13rem;
    font-size: 1.8rem;
  }
  &>div {
    float: right;
    ${OutlineButton} {
      margin-left: 5px;
    }
  }
`;

export const DetailPageQuestionCancelButton = styled(TextButton)`
  background: none;
  color: rgba(255, 255, 255, 0.75);
  transition: color 150ms;
  &:hover {
    color: ${({ theme }) => theme.gold[50]}
  }
`;

export const DetailPagePublicQuestionList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
